import React from "react";
import { ArrowRight, Phone, ShieldCheck, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const accessTypes = [{
  name: "Commercial & Industrial",
  to: "/CommercialScaffoldingPage"
}, {
  name: "Residential Projects",
  to: "/ResidentialScaffoldingPage"
}, {
  name: "Roofing Access",
  to: "/RoofingScaffoldingPage"
}, {
  name: "Specialist & Temporary Roofs",
  to: "/SpecialistAccessScaffoldingPage"
}];
const accreditationList = ["NASC Compliant Practices", "CHAS Accredited"];
export default function Guildford() {
  return <section id="guildfordhero" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground py-20 md:py-28 lg:py-32">
      {/* Background Decorative Grid Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary via-transparent to-transparent" />
      <div className="absolute inset-0 opacity-10 pointer-events-none bg-[linear-gradient(to_right,#ffffff10_1px,transparent_1px),linear-gradient(to_bottom,#ffffff10_1px,transparent_1px)] bg-[size:4rem_4rem]" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Main Hero Content */}
          <div className="lg:col-span-7 flex flex-col items-start space-y-6">
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="outline" className="border-primary/40 bg-primary/10 text-secondary-foreground py-1 px-3 text-xs tracking-wide">
                <ShieldCheck className="size-3.5 text-primary-foreground mr-1" />
                Guildford & Surrey Coverage
              </Badge>
              <span className="text-xs text-muted-foreground hidden sm:inline">
                Family-run accountability &bull; 20+ years expertise
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-default tracking-tight text-secondary-foreground leading-tight">
              Scaffolding in Guildford
            </h1>

            <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl font-normal leading-relaxed">
              Safe, professional scaffolding structures for commercial developments,
              residential properties, roofing contractors, and specialist access requirements across Guildford.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-primary text-primary-foreground shadow-md hover:bg-primary/90 font-medium px-6 text-base">
                <Link to="/ContactRequestQuotePage">
                  Request a quote
                  <ArrowRight className="size-4 ml-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-sidebar-border bg-sidebar/50 text-secondary-foreground hover:bg-sidebar hover:text-secondary-foreground focus-visible:text-secondary-foreground px-6 text-base">
                <a href="tel:01344929900" aria-label="Call BMF Scaffolding at 01344 929900" className="text-secondary-foreground hover:text-secondary-foreground">
                  <Phone className="size-4 mr-2 text-primary" />
                  Call 01344 929900
                </a>
              </Button>
            </div>

            {/* Accreditations Trust List */}
            <div className="pt-6 border-t border-sidebar-border/80 w-full">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">
                Accreditations & Compliance
              </p>
              <div className="flex flex-wrap items-center gap-y-2 gap-x-6">
                {accreditationList.map((item, i) => <div key={item} data-index={i} className="flex items-center gap-2 text-sm text-secondary-foreground/90 font-medium">
                    <CheckCircle2 className="size-4 text-primary shrink-0" />
                    <span>{item}</span>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Right Card / Capabilities Overview */}
          <div className="lg:col-span-5">
            <div className="rounded-2xl border border-sidebar-border bg-sidebar/70 backdrop-blur-xs p-6 sm:p-8 shadow-xl">
              <div className="mb-6">
                <span className="text-xs font-semibold uppercase tracking-wider text-primary">
                  Access Solutions
                </span>
                <h2 className="text-xl sm:text-2xl font-bold font-default text-secondary-foreground mt-1">
                  Tailored scaffolding for every project
                </h2>
                <p className="text-sm text-muted-foreground mt-2">
                  Explore access setups engineered to HSE standards and delivered on schedule by our qualified scaffolders.
                </p>
              </div>

              <div className="grid grid-cols-1 gap-3">
                {accessTypes.map((item, i) => <Link key={item.name} data-index={i} to={item.to} className="group flex items-center justify-between p-3.5 rounded-lg border border-sidebar-border/60 bg-secondary/60 hover:bg-sidebar hover:border-primary/40 transition-[background-color,border-color] duration-200">
                    <span className="text-sm font-medium text-secondary-foreground group-hover:text-primary-foreground">
                      {item.name}
                    </span>
                    <ArrowRight className="size-4 text-muted-foreground group-hover:text-primary transition-transform duration-200 group-hover:translate-x-1" />
                  </Link>)}
              </div>

              <div className="mt-6 pt-5 border-t border-sidebar-border/60 flex items-center justify-between text-xs text-muted-foreground">
                <span>Free site surveys & estimate turnarounds</span>
                <Link to="/AreasWeCoverPage" className="text-primary hover:underline font-medium inline-flex items-center gap-1">
                  View service areas
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}